import Modal from "../../../../../commons/Modal/Modal";
import { AssignProspectsModalProps } from "./AssignProspectsModal.types";
import AssignProspectsTable from "./AssignProspectsTable/AssignProspectsTable";

export default ({ ...props }: AssignProspectsModalProps) => {
  
  return (
    <Modal {...props} closeOnClickOutside>
      <h3>Assigner à un autre commercial</h3>
      <AssignProspectsTable />
    </Modal>
  )
}